import { ComponentType as c } from "../../registries/types/propTypes.js";
const d = (a) => {
  var s;
  const r = [], e = [];
  return a && ((s = a.categories) == null || s.forEach((o) => {
    var i;
    const n = (i = o.sub_categories) == null ? void 0 : i.map((t) => ({
      description: t.description,
      image: {
        images: t.image.images
      },
      logo: {
        images: t.logo.images
      },
      link: {
        text: t.link.text,
        url: t.link.url
      }
    }));
    r.push({
      title: o.header.text,
      id: o.header.url
    }), e.push({
      tabId: o.header.text,
      data: n
    });
  })), {
    componentType: c.about_amway_brands,
    brandData: {
      tabsData: r,
      tabsContent: e
    },
    activeTabId: a.activeTabId,
    brandTitle: a.title,
    callBack: a.callBack
  };
};
export {
  d as default
};
//# sourceMappingURL=about-amway-brands-transformer.js.map
